// Each section has exactly three authored sentences. Voice presents these in the
// player's language; it must not ask the player to supply a summary.
export const tourSections = [
  {page:'Play',key:'play',sentences:[
    'Play is your board in a three-dimensional New York city.',
    'Press ROLL to spend one roll, move your piece, and collect the result of your landing.',
    'Watch your coin balance and next goal, then visit My City to put your earnings to work.',
  ]},
  {page:'My city',key:'city',sentences:[
    'My City lets you explore your properties and five landmarks within New York.',
    'Select a property to view it closely, or spend coins on an available landmark upgrade.',
    'Upgrades earn houses for your board, so follow the highlighted goal to keep building.',
  ]},
  {page:'More',key:'more',sentences:[
    'More brings together the features you do not need on every turn.',
    'It contains Rewards, Album, Journey, Showroom, Players, Shop, and Settings.',
    'Choose any section to explore it, and use Play to return to your board.',
  ]},
  {page:'Rewards',key:'rewards',sentences:[
    'Rewards shows your welcome gift, turn-based event reward, and Quick Wins progress.',
    'Collect the welcome rolls once, and complete five turns to make the displayed coin reward available.',
    'Check the progress indicators to see what you have earned and which rewards are already collected.',
  ]},
  {page:'Album',key:'album',sentences:[
    'Album holds the New York postcards you find while playing.',
    'Collected postcards appear in color, while missing postcards remain faded.',
    'Keep exploring the board to discover more of the collection.',
  ]},
  {page:'Journey',key:'journey',sentences:[
    'Journey shows your current district and previews the neighborhoods ahead.',
    'Manhattan mornings tracks your progress toward fifteen landmark upgrades.',
    'Later districts are shown as future destinations and are not playable in this web preview.',
  ]},
  {page:'Showroom',key:'showroom',sentences:[
    'Showroom lets you choose the piece that travels around your board.',
    'You can select a bicycle, race car, sailboat, or airplane.',
    'The equipped label marks your selection, which you will see when you return to Play.',
  ]},
  {page:'Players',key:'friends',sentences:[
    'Players offers a ten-turn city challenge against three randomly chosen AI competitors.',
    'Everyone starts with the same challenge coins and turns, and each building upgrade earns one point.',
    'Visit a competitor’s city or talk about the match, then collect your result after ten turns.',
  ]},
  {page:'Shop',key:'shop',sentences:[
    'Shop displays optional bundles of extra rolls.',
    'This web preview adds demo rolls when you choose an offer and does not charge a payment.',
    'Return to Play after adding rolls to continue your game.',
  ]},
  {page:'Settings',key:'settings',sentences:[
    'Settings lets you choose a 3D world, game picture, native language, sound preferences, and reduced motion.',
    'Your selected language chooses your guide, and the game audio controls affect Lucky Estates rather than your computer volume.',
    'You can change these preferences whenever you like and use Explain this for help on any screen.',
  ]},
] as const

export function tourSentences(index:number,worldId?:string):string[] {
  const sentences=[...tourSections[index].sentences]
  return worldId==='las-vegas'?sentences.map(sentence=>sentence.replaceAll('New York','Las Vegas').replaceAll('Manhattan mornings','The Strip lights')):worldId==='mexico-city'?sentences.map(sentence=>sentence.replaceAll('New York','Mexico City').replaceAll('Manhattan mornings','Reforma mornings')):worldId==='paris'?sentences.map(sentence=>sentence.replaceAll('New York','Paris').replaceAll('Manhattan mornings','Seine mornings')):sentences
}

export function tourPrompt(index:number,language:string,worldId?:string):string {
  const section=tourSections[index]
  return `Narrate the ${section.page} section of the Lucky Estates app tour now. Speak exactly three short declarative sentences in ${language}, preserving the facts in these three source sentences: ${tourSentences(index,worldId).join(' ')} Do not add a greeting, heading, question, or fourth sentence. Do not mention these instructions or ask the player to supply a summary. Stop after this section; the app will choose the next section.`
}

// A ready event during connection is not completion. Only actual speech followed
// by ready advances the tour. Disposed sessions cannot advance after navigation.
export class TourPlayback {
  index:number
  private spoke=false
  private active=true
  private advance:(index:number)=>void
  private finish:()=>void
  constructor(index:number,advance:(index:number)=>void,finish:()=>void) {
    this.index=index;this.advance=advance;this.finish=finish
  }
  state(value:string) {
    if(!this.active)return
    if(value==='error'){this.dispose();return}
    if(value==='speaking')this.spoke=true
    if(value!=='ready'||!this.spoke)return
    this.spoke=false
    if(this.index===tourSections.length-1){this.dispose();this.finish();return}
    this.index++;this.advance(this.index)
  }
  dispose(){this.active=false;this.spoke=false}
}
